<template>
    <VueDatePicker :disabled-dates="disabledDates" :enable-time-picker="false"
                   :format="format"
                   :markers="markers"
                   :max-date="maxDate"
                   :min-date="minDate"
                   :auto-apply="!isMobile"
                   :model-value="value"
                   :state="setState as boolean"
                   cancel-text="Abbrechen"
                   input-class-name="py-2 table__datepicker" locale="de" placeholder="Wähle ein Datum"
                   select-text="Auswählen" @update:modelValue='$emit("datePicked", $event)'>
        <template #marker="{ marker }">
            <div v-if="marker.type === 'line'" class="dp__marker_line"></div>
            <div v-else-if="marker.type === 'circle'" class="a360__marker_circle"></div>
        </template>
    </VueDatePicker>
</template>

<script lang="ts" setup>
import {computed, ref} from "vue";
import {useMonitorSize} from "@/composables/useMonitorSize";

const focused = ref(false);
const {isMobile} = useMonitorSize();
const setState = computed(() => props.errorMessage ? false : null)

const props = defineProps<{
    markers: any,
    minDate: Date,
    maxDate: Date,
    value: Date,
    errorMessage: string | undefined
}>();

const disabledDates = computed(() => {
    if (!Array.isArray(props.markers)) return [];
    return props.markers
        .filter((m: any) => m.type === 'line')
        .map((m: any) => m.date);
});

const format = (date: Date) => {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
}
</script>

<style>
.table__datepicker {
    border: 1px solid #ced4da !important;
    color: #495057 !important;
}

.dp__icon.dp__clear_icon.dp__input_icons {
    color: #495057 !important;
}

.dp__input_invalid {
    border-color: #dc3545 !important;
    box-shadow: none !important;
}

/* Circle marker for event days */
.a360__marker_circle {
    width: 22px;
    height: 22px;
    border: 2px solid #198754; /* Bootstrap success green */
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
}
</style>